<script>
import { FormRelationField } from "stylemix-base";

export default {
  name: "FormCustomRelationField",
  extends: FormRelationField,
};
</script>

<style lang="scss">
.form-control.v-select {
  padding: 0 10px;
  .dropdown-toggle {
    border: none;
    padding: 0;

    &::after {
      display: none;
    }

    input[type="search"] {
      margin: 0;
    }
  }

  .selected-tag {
    margin: 8px;
    padding: 5px 10px;
    width: auto;
    /*background: #f8fcff;*/
    font-size: 14px;
    line-height: 14px;
    border: solid 1px #d3dee6;
    color: #a0aeb8;
    border-radius: 4px;
    height: auto;
    cursor: pointer;
    &:hover {
      background: #5ba0ed;
      border-color: #95c7ff;
      color: #fff;
    }
  }

  .vs__selected-options {
    margin-left: -7px;
    padding-left: 0;
  }
}
</style>
